function defaultState() {
    return {
        utilisateur: null,
        versions: {
            api: null,
            oauth2: null,
            front: null,
        },
    };
}

export default {
    namespaced: true,
    state: defaultState(),

    getters: {
        versions(state) {
            return state.versions;
        },
        uuid(state) {
            return state.utilisateur?.uuid;
        },
        email(state) {
            return state.utilisateur?.email;
        },
        civilite(state) {
            return state.utilisateur?.civilite;
        },
        libelle(state) {
            return [state.utilisateur?.prenom, state.utilisateur?.nom].filter(v => v).join(" ");
        },
        prenom(state) {
            return state.utilisateur?.prenom;
        },
        nom(state) {
            return state.utilisateur?.nom;
        },
        adresse(state) {
            return state.utilisateur?.adresse;
        },
        complementAdresse(state) {
            return state.utilisateur?.complementAdresse;
        },
        codePostal(state) {
            return state.utilisateur?.codePostal;
        },
        ville(state) {
            return state.utilisateur?.ville;
        }

    },

    mutations: {
        versions(state, versions) {
            state.versions.api = versions["/api"];
            state.versions.oauth2 = versions["/oauth2"];
        },
        logout(state) {
            const { utilisateur } = defaultState();
            state.utilisateur = utilisateur;

        },
        login(state,  utilisateur ) {
            state.utilisateur = utilisateur;

        },
    },
}
